import PropTypes from "prop-types";
import { setActiveSort } from "../../helpers/product";
import ReactStars from "react-rating-stars-component";
import { useTranslation } from "react-i18next";

const ShopRating = ({
  ratings,
  getSortParams,
  ratingFilter,
  setRatingFilter,
}) => {
  const { t } = useTranslation();

  return (
    <div className="sidebar-widget mt-40">
      <h4 className="pro-sidebar-title">{t("filter_by_rating")} </h4>
      <div className="sidebar-widget-list mt-20">
        {ratings ? (
          <ul>
            {Array.from({ length: 5 }, (_, index) => index + 1).map(
              (rating, key) => {
                return (
                  <li key={key}>
                    <div className="sidebar-widget-list-left d-flex">
                      <button
                        className={`${
                          ratingFilter?.includes(key + 1) ? "active" : ""
                        }`}
                        onClick={(e) => {
                          if (ratingFilter.includes(key + 1)) {
                            setRatingFilter(
                              ratingFilter.filter((item) => item !== key + 1)
                            );
                          } else setRatingFilter([...ratingFilter, key + 1]);
                        }}
                      >
                        {" "}
                        <span className="checkmark" />
                      </button>
                      <div className="d-flex gap-2 flex-nowrap flex-grow-1 w-100">
                        {key == 0 && (
                          <ReactStars
                            count={1}
                            size={24}
                            value={1}
                            edit={false}
                          />
                        )}
                        {key == 1 && (
                          <ReactStars
                            count={2}
                            size={24}
                            value={2}
                            edit={false}
                          />
                        )}
                        {key == 2 && (
                          <ReactStars
                            count={3}
                            size={24}
                            value={3}
                            edit={false}
                          />
                        )}
                        {key == 3 && (
                          <ReactStars
                            count={4}
                            size={24}
                            value={4}
                            edit={false}
                          />
                        )}
                        {key == 4 && (
                          <ReactStars
                            count={5}
                            size={24}
                            value={5}
                            edit={false}
                          />
                        )}
                      </div>
                    </div>
                  </li>
                );
              }
            )}
          </ul>
        ) : (
          "لا توجد تقييمات"
        )}
      </div>
    </div>
  );
};

ShopRating.propTypes = {
  getSortParams: PropTypes.func,
  ratings: PropTypes.array,
};

export default ShopRating;
